// src/styles/colors.ts

export const colors = {
    primary: "#1E90FF",     // Primary brand color (e.g., Dodger Blue)
    secondary: "#FF6347",   // Secondary brand color (e.g., Tomato)
    success: "#28a745",     // Success messages or actions (e.g., Green)
    danger: "#dc3545",      // Error or danger messages (e.g., Red)
    warning: "#ffc107",     // Warnings (e.g., Yellow)
    info: "#17a2b8",        // Informational messages (e.g., Cyan)
    light: "#f8f9fa",       // Light background (e.g., Light Grey)
    dark: "#343a40",        // Dark background (e.g., Dark Grey)
    
    // Grayscale
    white: "#FFFFFF",       // Pure White
    grayLight: "#E1E1E1",   // Light Gray (e.g., Border color)
    grayMedium: "#6C757D",  // Medium Gray (e.g., Text color)
    grayDark: "#343A40",    // Dark Gray (e.g., Background color)
    black: "#000000",       // Pure Black
  
    // Additional Colors
    background: "#F4F4F9",  // General background color (e.g., Light greyish)
    textPrimary: "#212529", // Primary text color (e.g., Very dark grey)
    textSecondary: "#6C757D", // Secondary text color (e.g., Medium grey)
    link: "#1E90FF",        // Link color (e.g., Dodger Blue)
    linkHover: "#0056b3",   // Link hover color (e.g., Darker blue)
    
    // Other custom colors
    successLight: "#8FD19E", // Lighter green for success backgrounds
    dangerLight: "#F5B7B1",  // Lighter red for error backgrounds
    warningLight: "#FFE083", // Lighter yellow for warning backgrounds
    infoLight: "#A0E7E5",    // Lighter cyan for info backgrounds
  };
  
  export default colors;
  